import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';
import { environment as env } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class AppTitleService {
    private entityName = new BehaviorSubject<string | null>(null);
    entityTitle$ = this.entityName.asObservable();

    constructor(private titleService: Title) {}

    setEntityTitle(title: string | null): void {
        this.entityName.next(title);
    }

    setTitle(title: string): void {
        this.titleService.setTitle(`${env.titlePrefix} ${title}`);
    }

    updateTitle(title?: string): void {
        const entityTitle = this.entityName.getValue();
        if (entityTitle && title) {
            this.titleService.setTitle(
                `${env.production ? '' : '[DEV]'} ${entityTitle}: ${title}`
            );
        } else if (entityTitle) {
            this.titleService.setTitle(
                `${env.production ? '' : '[DEV]'} ${
                    env.titlePrefix
                } ${entityTitle}`
            );
        } else if (title) {
            this.titleService.setTitle(
                `${env.production ? '' : '[DEV]'} ${env.titlePrefix} ${title}`
            );
        } else {
            this.titleService.setTitle(`${env.titlePrefix}`);
        }
    }
}
